export * from './translate-enum-pipe-base';
